import { Component, OnInit, Input } from '@angular/core';
import { ConsumerCurriculumJargon } from 'src/app/Elearning-Models';
import { IServiceFactory } from 'src/app/Services/service-factory';
import { CurriculumService } from 'src/app/Services/curriculum.service';

@Component({
  selector: 'app-consumer-curriculum-registration-steps',
  templateUrl: './consumer-curriculum-registration-steps.component.html',
  styleUrls: ['./consumer-curriculum-registration-steps.component.scss']
})
export class ConsumerCurriculumRegistrationStepsComponent implements OnInit {

  stepOneColor: string;
  stepTwoColor: string;
  stepThreeColor: string;

  currService: CurriculumService;

  jargon: ConsumerCurriculumJargon;

  @Input() whichStep: number;
  constructor(private serviceFactory: IServiceFactory) {
    this.currService = this.serviceFactory.getCurriculumService();
   }

  ngOnInit(): void {
    
    this.jargon = this.currService.jargon;

    this.stepOneColor = this.whichStep == 1 ? 'registeron' : 'registeroff';
    this.stepTwoColor = this.whichStep == 2 ? 'registeron' : 'registeroff';
    this.stepThreeColor = this.whichStep == 3 ? 'registeron' : 'registeroff';

  }

}
